module.exports = {
    "dismiss": `Descartar`
};


//# sourceMappingURL=pt-BR.main.js.map
